import type { Engine } from '@/lib/ai/constants'
import { ENGINE_LABELS } from '@/lib/ai/constants'

export type MarketingEngine = {
  id: Engine
  displayName: string
  logoSrc: string
  visibilityPageHref: string
  shortDescription: string
  isAddon: boolean
}

export const MARKETING_ENGINES: MarketingEngine[] = [
  {
    id: 'chatgpt',
    displayName: ENGINE_LABELS.chatgpt,
    logoSrc: '/images/ai-platforms/chatgpt-logo.svg',
    visibilityPageHref: '/chatgpt-visibility',
    shortDescription: 'Track brand mentions in ChatGPT responses',
    isAddon: false,
  },
  {
    id: 'perplexity',
    displayName: ENGINE_LABELS.perplexity,
    logoSrc: '/images/ai-platforms/perplexity-logo.svg',
    visibilityPageHref: '/perplexity-visibility',
    shortDescription: 'Monitor visibility in Perplexity AI answers',
    isAddon: false,
  },
  {
    id: 'google_aio',
    displayName: ENGINE_LABELS.google_aio,
    logoSrc: '/images/ai-platforms/google-aio-logo.svg',
    visibilityPageHref: '/google-aio-visibility',
    shortDescription: 'Track brand placement in Google AI Overview summaries',
    isAddon: false,
  },
]

export const BASE_MARKETING_ENGINES = MARKETING_ENGINES.filter((e) => !e.isAddon)

export const ADDON_MARKETING_ENGINES = MARKETING_ENGINES.filter((e) => e.isAddon)

/**
 * Human-readable engine name list.
 *
 * formatEngineNames()                     → 'ChatGPT, Perplexity & Google AI Overview'
 * formatEngineNames({ baseOnly: true })   → 'ChatGPT, Perplexity & Google AI Overview'
 * formatEngineNames({ addonLabel: true }) → 'ChatGPT, Perplexity & Google AI Overview'
 */
export function formatEngineNames(opts?: { baseOnly?: boolean; addonLabel?: boolean }): string {
  const engines = opts?.baseOnly ? BASE_MARKETING_ENGINES : MARKETING_ENGINES
  const names = engines.map((e) => {
    let name = e.displayName
    if (opts?.addonLabel && e.isAddon) name += ' (add-on)'
    return name
  })
  if (names.length <= 1) return names[0] ?? ''
  const last = names[names.length - 1]!
  return names.slice(0, -1).join(', ') + ' & ' + last
}
